import React from 'react'

export default function AddVisitCds() {
    return (
        <div>Add Visit Passed</div>
    )
}
